import { createAction } from '@reduxjs/toolkit';

export const progress = createAction<string>('app/progress');
export const complete = createAction<string>('app/complete');
